const config = {
    "apiEndpoints": {
        "vehicleList": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/VehicleList"
        },
        "addressBook": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/AddressBookList"
        },
        "liveTracking": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/liveTracking"
        },
        "jobList": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/JobList?page=:page&from=:from&to=:to&status=:status"
        },
        "jobsDetail": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/jobDetails"
        },
        "jobsCountData": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/jobCountData?from=:from&to=:to&status=:status"
        },
        "geFullPath": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/geFullPath"
        },
        "getVehiclelocation": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/getVehiclelocation"
        },
        "getVehiclePath": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/vehiclePath"
        },
        "getVehiclePathUser": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/vehiclePath-user"
        },
        "userGetVehiclePath": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/user/vehiclePath",
        },
        "userAuthToken": {
            "host": "livetracking",
            "url": "/api/v1/livetracking/setCookies",
        },
        "getDailyData":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/getdata"
        },
        "liveTrackingReport": {
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report",
        },
        "liveTrackingReportWeek":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-w"
        },
        "punctualityReport": {
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/detail?jobId=:jobId",
        },
        "moreDetailWeekReport": {
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-w-detail",
        },
        "punctualityReportDownload":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/download"
        },
        "punctualityReportWeekDownload":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-w-download"
        },

        "liveTrackingReportOrigin":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-org-dest",
        },
        "punctualityReportOriginDownload":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-orgDest-download",
        },
        "punctualityReportOriginDetailedDownload":{
            "host": "LIVETRACKING",
            "url": "/api/v1/punctuality-report/report-orgDest-detailed-download?jobId=:jobId",
        },
        // search api for city
        "searchCity": {
            "host": "search",
            "url": "/v1/bus/city?q=:city",
        }
    }
}

export default config;